import { startCase } from "lodash";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import {
  formatValueDynamically,
  getFormattedValue,
} from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface SpaceGroupCardProps {
  params: Record<string, string | boolean>;
  url: string;
}

export const SpaceGroupCard = ({ params, url }: SpaceGroupCardProps) => {
  const orderedFields: Array<
    [string, { label: string; type: string; defaultValue?: boolean }]
  > = [
    ["name", { label: t("name", { defaultValue: "Name" }), type: "string" }],
    [
      "slug",
      {
        label: t("space_groups.form.create.slug", {
          defaultValue: "Custom URL slug",
        }),
        type: "string",
      },
    ],
    [
      "hide_members_count",
      {
        label: t("space_groups.form.create.hide_members_count", {
          defaultValue: "Hide member count",
        }),
        type: "boolean",
      },
    ],
    [
      "is_hidden_from_non_members",
      {
        label: t("space_groups.form.create.is_hidden_from_non_members", {
          defaultValue: "Hide from non-space members",
        }),
        type: "boolean",
      },
    ],
    [
      "hide_non_member_spaces_from_sidebar",
      {
        label: t("space_groups.form.hide_non_member_spaces_from_sidebar", {
          defaultValue: "Only show joined spaces in sidebar",
        }),
        type: "boolean",
      },
    ],
    [
      "allow_members_to_create_spaces",
      {
        label: t("space_groups.form.allow_members_to_create_spaces", {
          defaultValue: "Allow members to create spaces",
        }),
        type: "boolean",
      },
    ],
  ];

  const PROFILE_FIELDS = Object.fromEntries(orderedFields);

  return (
    <PreviewCardLayout
      title={t(
        "help_widget.copilot.preview_cards.create_space_group_card_title",
      )}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(PROFILE_FIELDS).flatMap(([key, keyProps]) => {
          const hasValueInParams = key in params && params[key] != null;
          const value = hasValueInParams ? params[key] : keyProps.defaultValue;

          if (value == null) return [];

          return [
            <li key={key} className="text-darkest !pb-0">
              <Typography.BodySm color="text-darkest">
                <strong>{keyProps.label}:</strong>{" "}
                {getFormattedValue(value, keyProps.type)}
              </Typography.BodySm>
            </li>,
          ];
        })}
        {Object.entries(params)
          .filter(([key, value]) => !(key in PROFILE_FIELDS) && value != null)
          .map(([key, value]) => (
            <li key={key} className="text-darkest !pb-0">
              <Typography.BodySm color="text-darkest">
                <strong>{startCase(key)}:</strong>{" "}
                {formatValueDynamically(value)}
              </Typography.BodySm>
            </li>
          ))}
      </ul>
    </PreviewCardLayout>
  );
};
